import { render, staticRenderFns } from "./navigate-buttons.vue?vue&type=template&id=4f071cd1&scoped=true"
import script from "./navigate-buttons.vue?vue&type=script&lang=js"
export * from "./navigate-buttons.vue?vue&type=script&lang=js"
import style0 from "./navigate-buttons.vue?vue&type=style&index=0&id=4f071cd1&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f071cd1",
  null
  
)

export default component.exports